/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.deal.plans.rpc.DealPlanPortalRpc
 */

export let ComHubspotCrmPropertiesDefaultsOptionsDealplan;
(function (_ComHubspotCrmPropertiesDefaultsOptionsDealplan) {})(ComHubspotCrmPropertiesDefaultsOptionsDealplan || (ComHubspotCrmPropertiesDefaultsOptionsDealplan = {}));
export let ComHubspotCrmPropertiesDefaultsOptionsDealplanmilestone;
(function (_ComHubspotCrmPropertiesDefaultsOptionsDealplanmilestone) {})(ComHubspotCrmPropertiesDefaultsOptionsDealplanmilestone || (ComHubspotCrmPropertiesDefaultsOptionsDealplanmilestone = {}));
export const BuyerCandidateTypename = 'com.hubspot.deal.plans.models.rpc.BuyerCandidate';
export const BuyerCandidateDiscriminant = 'BUYER';
export const BuyerCandidateDiscriminantKey = 'ownerType';
export const BuyerOwnerTypename = 'com.hubspot.deal.plans.models.rpc.BuyerOwner';
export const BuyerOwnerDiscriminant = 'BUYER';
export const BuyerOwnerDiscriminantKey = 'ownerType';
export const CompanyCandidateTypename = 'com.hubspot.deal.plans.models.rpc.CompanyCandidate';
export const CompanyCandidateDiscriminant = 'COMPANY';
export const CompanyCandidateDiscriminantKey = 'ownerType';
export const CompanyOwnerTypename = 'com.hubspot.deal.plans.models.rpc.CompanyOwner';
export const CompanyOwnerDiscriminant = 'COMPANY';
export const CompanyOwnerDiscriminantKey = 'ownerType';
export const DealPlanBuyerTypename = 'com.hubspot.deal.plans.models.rpc.DealPlanBuyer';
export const DealPlanBuyerDiscriminant = 'BUYER';
export const DealPlanBuyerDiscriminantKey = 'ownerType';
export const DealPlanCompanyAssigneeTypename = 'com.hubspot.deal.plans.models.rpc.DealPlanCompanyAssignee';
export const DealPlanCompanyAssigneeDiscriminant = 'COMPANY';
export const DealPlanCompanyAssigneeDiscriminantKey = 'ownerType';
export const DealPlanSellerTypename = 'com.hubspot.deal.plans.models.rpc.DealPlanSeller';
export const DealPlanSellerDiscriminant = 'SELLER';
export const DealPlanSellerDiscriminantKey = 'ownerType';
export const MilestoneAssigneeDiscriminantKey = 'ownerType';
export const MilestoneOwnerDiscriminantKey = 'ownerType';
export const OwnerCandidateDiscriminantKey = 'ownerType';
export const SellerCandidateTypename = 'com.hubspot.deal.plans.models.rpc.SellerCandidate';
export const SellerCandidateDiscriminant = 'SELLER';
export const SellerCandidateDiscriminantKey = 'ownerType';
export const SellerOwnerTypename = 'com.hubspot.deal.plans.models.rpc.SellerOwner';
export const SellerOwnerDiscriminant = 'SELLER';
export const SellerOwnerDiscriminantKey = 'ownerType';
export const getDealPlanRpc = {
  serviceName: 'com.hubspot.deal.plans.rpc.DealPlanPortalRpc',
  rpcName: 'getDealPlan',
  auth: 'external',
  fingerprint: 'cQlinko4p0dW0K-fCvQBrAnMjhu8G_1E',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getOwnerCandidatesRpc = {
  serviceName: 'com.hubspot.deal.plans.rpc.DealPlanPortalRpc',
  rpcName: 'getOwnerCandidates',
  auth: 'external',
  fingerprint: 'yDT1uVGoVRiEaGZhXjR2fQnMjhu8G_1E',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createMilestoneRpc = {
  serviceName: 'com.hubspot.deal.plans.rpc.DealPlanPortalRpc',
  rpcName: 'createMilestone',
  auth: 'external',
  fingerprint: 'NXeTBGW3GKLO7iwff1O-IwnMjhu8G_1E',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateMilestoneRpc = {
  serviceName: 'com.hubspot.deal.plans.rpc.DealPlanPortalRpc',
  rpcName: 'updateMilestone',
  auth: 'external',
  fingerprint: 'DMJE55MVlyu-b8XwmE85XwnMjhu8G_1E',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteMilestoneRpc = {
  serviceName: 'com.hubspot.deal.plans.rpc.DealPlanPortalRpc',
  rpcName: 'deleteMilestone',
  auth: 'external',
  fingerprint: 'MxWOnSQA9fmWMYaa0T4skwnMjhu8G_1E',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateDealPlanRpc = {
  serviceName: 'com.hubspot.deal.plans.rpc.DealPlanPortalRpc',
  rpcName: 'updateDealPlan',
  auth: 'external',
  fingerprint: 'OSdqf3VhaYY6N8lyosE80AnMjhu8G_1E',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteDealPlanRpc = {
  serviceName: 'com.hubspot.deal.plans.rpc.DealPlanPortalRpc',
  rpcName: 'deleteDealPlan',
  auth: 'external',
  fingerprint: '6bqjFge86DRkinULGm8fXQnMjhu8G_1E',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};